// Mirrors C# `KpdReportPatientOutcome` / view `view_PatientOutcomes`.
// Notes:
// - C# `DateTime?` -> `string | null` (API typically sends ISO strings)
// - C# `long?` -> `number | null`
// - C# non-nullable primitives -> `number` / `boolean`
export interface IPatientOutcomes {
    swapNumber: number | null;
    swapCluster: number | null;
    swapPosition: number;
    transplantDate: string | null;

    unosId: string;

    isChainEndRecipient: boolean | null;
    isVoucherRecipient: boolean | null;
    isDirect: boolean | null;
    isRemoteDirect: boolean | null;

    recipientCenterId: number;
    recipientCenter: string;
    recipientId: number;
    recipientAlias: string;

    recipientTypeId: number | null;
    recipientType: string;

    recipientsIntendedDonorType: string;
    recipientsIntendedDonorRelationship: string;

    recipientExcludedFromDataCompliance: boolean | null;
    recipientLostToFollowup: boolean;
    recipientGender: string;
    recipientHeight: number | null;
    recipientWeight: number | null;
    recipientEthnicity: string;
    recipientAbo: string;
    recipientCmvStatus: string;
    recipientEbvStatus: string;
    recipientAntiATiters: string;
    recipientAntiATiterValue: string;
    recipientNkrCpra: number | null;
    recipientUnosCpra: string;
    recipientUnosListDate: string | null;
    recipientIsPreemptive: boolean | null;
    recipientDialysisStartDate: string | null;
    recipientDialysisMonths: number | null;
    recipientNkrWaitDays: number | null;
    recipientNkrWaitMonths: number | null;
    recipientAgeAtTransplant: number | null;

    donorCenterId: number;
    donorCenter: string;
    donorId: number;
    donorAlias: string;
    donorTypeId: number;
    donorType: string;
    donorGender: string;
    donorHeight: number | null;
    donorWeight: number | null;
    donorEthnicity: string;
    donorAbo: string;
    donorKidneySide: string;
    donorKidneyArteries: number | null;
    donorKidneyVeins: number | null;
    donorKidneyUreters: number | null;
    donorCreatinineClearance: number | null;
    donorSerumCreatinine: number | null;
    donorUrineProtein: string;
    donorAgeAtTransplant: number | null;

    recipientCenterPostalCode: string;
    donorCenterPostalCode: string;
    kidneyPickupDateTime: string | null;
    kidneyArrivalDateTime: string | null;
    kidneyTransitTimeMinutes: number | null;
    kidneyTransitType: string;
    kidneyTransitMiles: number | null;
    citHours: number | null;

    hlaMatchPoints: number | null;
    hlaMismatchesA: number | null;
    hlaMismatchesB: number | null;
    hlaMismatchesDr: number | null;

    epletMmRisk: string;

    wasDesensitized: boolean | null;
    desensitizationType: string;
    hadDelayedGraftFunction: number;
    hadPrimaryNonFunction: boolean;
    didGraftSurvive: boolean;
    graftFailureDate: string | null;

    recipientRejectionEpisodes: boolean;
    recipientRejectionEpisodeDetail: string;
    recipientCreatinine1Month: string;
    recipientCreatinine1MonthDate: string | null;
    recipientCreatinine6Month: string;
    recipientCreatinine6MonthDate: string | null;
    recipientCreatinine1Year: string;
    recipientCreatinine1YearDate: string | null;
    recipientCreatinine2Year: string;
    recipientCreatinine2YearDate: string | null;
    recipientCreatinine3Year: string;
    recipientCreatinine3YearDate: string | null;
    recipientCreatinine4Year: string;
    recipientCreatinine4YearDate: string | null;
    recipientCreatinine5Year: string;
    recipientCreatinine5YearDate: string | null;
    recipientCreatinine6Year: string;
    recipientCreatinine6YearDate: string | null;
    recipientCreatinine7Year: string;
    recipientCreatinine7YearDate: string | null;
    recipientCreatinine8Year: string;
    recipientCreatinine8YearDate: string | null;
    recipientCreatinine9Year: string;
    recipientCreatinine9YearDate: string | null;
    recipientCreatinine10Year: string;
    recipientCreatinine10YearDate: string | null;

    recipientIsAlive: boolean | null;
    recipientDeceasedDate: string | null;
    recipientDeceasedPrimaryCause: string;
    recipientDeceasedSecondaryCause: string;

    kidneyLifeYears: number | null;
}